<ng-template #overlayContent>
    <div class="overlay-content">
        @switch (currentContentType) {
            @case ("search") {
                <cipo-search-result (documentOpened)="onDocumentOpened()" />
            }
            @case ("cipo-ai") {
                <cipo-ai />
            }
        }
    </div>
</ng-template>
